import { useSelector } from 'react-redux'
import { IntegrationConfigSence, ISenceIntegration } from 'models/integrations'
import { IMainState } from 'store/states'
import { getJWT } from 'helpers/cookies.helper'
import { formatSenceRut } from 'helpers'

interface FormCommonProps {
  data: ISenceIntegration
  params: IntegrationConfigSence
  success: string
  error: string
}

export const FormCommon = ({
  data,
  params,
  success,
  error,
}: FormCommonProps) => {
  const rut = useSelector(({ user }: IMainState) => user.user.rut)

  const rutFormatted = formatSenceRut(rut)

  const idSession = getJWT()

  return (
    <>
      <input type="hidden" value={params.runOtec || ''} name="RutOtec" />
      <input type="hidden" value={params.token || ''} name="Token" />
      <input type="hidden" value={data.code} name="CodSence" />
      <input type="hidden" value={data.courseCode} name="CodigoCurso" />
      <input type="hidden" value={data.trainingLine} name="LineaCapacitacion" />
      <input type="hidden" value={success} name="UrlRetoma" />
      <input type="hidden" value={error} name="UrlError" />
      <input type="hidden" value={rutFormatted} name="RunAlumno" />
      <input type="hidden" value={idSession} name="IdSesionAlumno" />
    </>
  )
}
